import { StatusBar } from "@shared/primitive-components"
import { useMemo } from "react"
import { usePolicyAccessCapabilities } from "../../hooks"
import { isConnectivityTargetMet } from "../../utils"
import { TargetNotMet } from "./SafetyInsightsComponents"
import { Policy } from "../../api/policy"

// --------------------------------------------------------------------------------------------------------------------

export const CONNECTIVITY_TARGET_BAR_DTI = `connectivity_target_bar`

type LowConnectivityBannerProps = {
  policy: Policy
}
// --------------------------------------------------------------------------------------------------------------------

export const LowConnectivityBanner = ({ policy }: LowConnectivityBannerProps) => {
  const { isRebatePolicy, isRebateV2Policy } = usePolicyAccessCapabilities()

  const showLowConnectivityBanner = useMemo(() => {
    const ratio = policy.connectivityRatio ?? 0
    const connectedPercentage = Math.round(ratio * 100)
    const disconnectedPercentage = 100 - connectedPercentage

    return !isConnectivityTargetMet(connectedPercentage, disconnectedPercentage) && isRebateV2Policy
  }, [isRebateV2Policy, policy.connectivityRatio])

  return (
    <>
      {showLowConnectivityBanner && (
        <StatusBar
          type="error"
          placement="top"
          message={TargetNotMet(isRebatePolicy, isRebateV2Policy)}
          dataTestId={CONNECTIVITY_TARGET_BAR_DTI}
        />
      )}
    </>
  )
}
